<template>
  <div>
    <BaseModal
      :id="'change-nickName-modal'"
      cancel-btn
      @clickConfirm="requestChangeNickName"
      @clickCancel="closeAlert('change-nickName-modal')"
    >
      <template slot="title">{{ $t('modal.nickname.title') }}</template>
      <template slot="content">
        <div class="gap-rows">
          <div>
            <div>{{ $t('modal.nickname.content') }}</div>
            <div>
              {{ $t('modal.nickname.content1') }}
            </div>
            <div>{{ $t('modal.nickname.content2') }}</div>
            <div>{{ $t('modal.nickname.content3') }}</div>
          </div>
          <div class="paragraph" style="padding-right: 22px">
            <div>{{ $t('modal.nickname.content4') }}</div>
            <div class="sub">
              <p>{{ $t('modal.nickname.content5') }}</p>
              <p>{{ $t('modal.nickname.content6') }} {{ $t('modal.nickname.content7') }}</p>
              <p>{{ $t('modal.nickname.content8') }}</p>
            </div>
          </div>
          <div v-html="$t('modal.nickname.content9')"></div>
        </div>
        <div id="nickname-input-field">
          <div class="d-grid">
            <input
              class="mt-3"
              :class="{
                validations: validationText !== '',
                true: isNotDuplicated,
              }"
              type="text"
              v-model="nickName"
              maxlength="10"
              :placeholder="$t('modal.nickname.placeholder')"
              @focus="checkProfanity"
              @blur="resetInput"
            />
            <div @click="duplicateCheck" class="mt-3 duplicate-check">
              {{ $t('modal.nickname.duplicatecheck') }}
            </div>
          </div>
          <div class="validation nickname" :class="`${isNotDuplicated}`">
            {{ $t(validationText) }}
          </div>
        </div>
      </template>
      <template slot="confirm">{{ $t('modal.nickname.confirm') }}</template>
    </BaseModal>
    <BaseModal
      :id="'change-nickName-success-modal'"
      cancel-btn
      @clickCancel="closeAlert('change-nickName-success-modal')"
      @clickConfirm="newCommunity"
    >
      <template slot="title">{{ $t('modal.nickname.title') }}</template>
      <template slot="content">
        {{ $t('modal.nickname.success.content') }}<br />
        {{ $t('modal.nickname.success.content1') }}
      </template>
      <template slot="confirm">{{ $t('modal.nickname.success.confirm') }}</template>
    </BaseModal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseModal from '@/views/Modal/BaseModal.vue';
import profanities from '@/assets/profanity';
import XRegExp from 'xregexp';

export default {
  components: {
    BaseModal,
  },
  name: 'changeNickName',
  props: {},
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
      newCommunityPage: (state) => state.newCommunity,
    }),
  },
  data() {
    return {
      nickName: '',
      validationText: '',
      validation: false,
      isNotDuplicated: false,
    };
  },
  methods: {
    closeAlert(str) {
      this.$bvModal.hide(str);
      this.nickName = '';
      this.validationText = '';
      this.validation = false;
    },
    regTest(reg) {
      return reg.test(this.nickName);
    },
    profanityTest() {
      for (const i in profanities) {
        if (Object.hasOwnProperty.call(profanities, i)) {
          const el = profanities[i];
          const testNick = this.nickName.trim().replace(/(\s*)/g, '').replace(/[0-9]/g, '');

          if (testNick.includes(el) | testNick.replace(/[^가-힣]/g, '').includes(el)) {
            return true;
          }
        }
      }
      return false;
    },
    checkProfanity() {
      const _reg = XRegExp('[^\\p{L}0-9]+', 'gm');
      const _reg1 = XRegExp('[ㄱ-ㅎ]+', 'gm');
      const _reg2 = XRegExp('[ㅏ-ㅣ]+', 'gm');
      const _reg3 = XRegExp('^[0-9]+$', 'g');

      if (!this.isNotDuplicated) {
        if (
          this.regTest(_reg) |
          this.regTest(_reg1) |
          this.regTest(_reg2) |
          this.regTest(_reg3) |
          this.profanityTest()
        ) {
          this.validation = false;
          this.validationText = 'modal.nickname.validation';
        } else if (this.nickName.length < 3) {
          this.validation = false;
          this.validationText = 'modal.nickname.validation1';
        } else {
          this.validation = true;
          this.validationText = '';
        }
      }
    },
    requestChangeNickName() {
      if (this.validation && this.isNotDuplicated) {
        this.$axios
          .put(
            `${process.env.VUE_APP_TEST_SERVER}/user/nickName`,
            {
              nickName: this.nickName,
            },
            {
              headers: { 'Content-Type': 'application/json' },
              withCredentials: true,
            }
          )
          .then(() => {
            this.closeAlert('change-nickName-modal');
            this.$bvModal.show('change-nickName-success-modal');
            this.$store.dispatch('getLoginState');
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$bvModal.show('login-required');
            } else {
              const errMessage = String(err.response.data.message);
              this.validation = false;
              this.validationText = errMessage;
            }
          });
      } else if (this.validation && !this.isNotDuplicated) {
        this.validation = false;
        this.validationText = 'modal.nickname.validation2';
      }
    },
    newCommunity() {
      this.$gtag.event('커뮤니티 등록', {
        event_category: '커뮤니티',
        event_label: '커뮤니티 등록',
      });
      this.$bvModal.hide('change-nickName-success-modal');
      this.$router.push({ name: this.newCommunityPage });
    },
    resetInput() {
      if (this.nickName === '') {
        this.validationText = '';
      }
    },
    duplicateCheck() {
      if (this.validation && !this.isNotDuplicated) {
        this.$axios
          .get(`${process.env.VUE_APP_TEST_SERVER}/user/duplicateNickName`, {
            params: {
              nickName: this.nickName,
            },
          })
          .then(() => {
            this.isNotDuplicated = true;
            this.validationText = 'modal.nickname.validation3';
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$bvModal.show('login-required');
            } else {
              const errMessage = String(err.response.data.message);
              this.validation = false;
              this.validationText = errMessage;
            }
          });
      }
    },
  },
  watch: {
    nickName() {
      this.isNotDuplicated = false;
      this.checkProfanity();
    },
  },
};
</script>

<style lang="scss">
#nickname-input-field {
  margin-right: 28px;
  font-size: 18px;

  input.validations {
    border: 1px solid #e56767;

    &.true {
      border: 1px solid #3c7eea;
    }
  }

  .d-grid {
    grid-template-columns: 1fr auto;
    gap: 8px;

    .duplicate-check {
      display: grid;
      place-content: center;
      border: 1px solid #3c7eea;
      border-radius: 4px;
      color: #3c7eea;
      padding: 0 16px;

      @media screen and (max-width: 1119px) {
        padding: 0 10px;
        font-size: 16px;
      }
    }
  }

  @media screen and (max-width: 1119px) {
    margin-right: 22px;
    font-size: 14px;
  }

  .validation.nickname {
    text-align: left;
    color: #e56767;
    font-size: 14px;
    height: fit-content;
    padding: 0;
    padding-left: 5px;
    padding-top: 2px;

    &.true {
      color: #3c7eea;
    }

    @media screen and (max-width: 1119px) {
      font-size: 12px;
    }
  }
}
</style>
